<template>
    <m-main-layout>
	    {{formData}}
        <div class="page-content-main">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="auto" class="margin-top">
                <el-form-item label="ID" v-if="formData.industryCategoryId">
                  {{formData.industryCategoryId}}
                </el-form-item>
                <el-form-item label="名称" prop="industryCategoryName">
                    <el-input v-model="formData.industryCategoryName"   style="width: 500px;"></el-input>
                </el-form-item>
                 <el-form-item label="排序" prop="sort">
                    <el-input v-model="formData.sort"   style="width: 500px;"></el-input>
                    排序数字越小越靠前
                </el-form-item>
                  <el-form-item label="状态" prop="state">
                    <el-switch
                        v-model="formData.state"
                        active-color="#13ce66"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="适用板块" prop="applicablePlateList">
                    <el-checkbox-group v-model="formData.applicablePlateList">
                      <el-checkbox label="notice">招标公告</el-checkbox>
                      <el-checkbox label="odd">散单专区</el-checkbox>
                      <el-checkbox label="storage">仓储供给</el-checkbox>
                      <el-checkbox label="device">设备专区</el-checkbox>
                      <el-checkbox label="coldChain" >冷链专区</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
export default {
    name: "add",
    data() {
        return {
            formData: {
                applicablePlateList:[],
                applicablePlateNameList:[],
                industryCategoryId:'',
                industryCategoryName: '',
                sort:0,
                state: 1
            },
            typeList: [],
            rules: {
                industryCategoryName: [{required: true, message: '名称必填'}],
                sort: [
                  {message: '请填写正确的排序',validator:this.$utils.must09}
                ],
            },
            routerData:null,
            url:'',
        };
    },
    created() {
      if(Object.keys(this.$route.query).length&&Object.keys(this.$route.query.rowData).length){
        this.formData.industryCategoryId  = this.$route.query.rowData.industryCategoryId;
      }
      let _config = window.config.paths();
      let _path = this.$route.path.replace('/edit','');

      this.params = _config[_path];

      this.routerData = this.params.routerData ? this.params.routerData : {};
    },
    mounted() {
        if(this.formData.industryCategoryId) {
          this.getDetail();
        }
    },
    methods: {
        submitForm(formName) {
            let _this = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // _this.$http.httpPost({
                    //     url: "/admin/industryCategory/saveOrUpdateIndustryCategory",
                    //     datas: this.formData,
                    //     type:'json',
                    //     success: (res) => {
                    //         _this.$utils.success("保存成功！");
                    //         _this.$router.back();
                    //     }
                    // });
	                _this.$http.httpPost({
		                url: "/industryCategory/saveOrUpdateIndustryCategory",
		                datas: this.formData,
		                success: (res) => {
			                _this.$utils.success("保存成功！");
			                _this.$router.back();
		                }
	                });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getDetail(){
            this.formData = this.$route.query.rowData;
        },
    }
}
</script>
